import { FaBlog, FaEdit, FaUserCircle } from 'react-icons/fa';
import { MdEditNote, MdDeleteSweep } from 'react-icons/md';

export const sidebarNav = [
  { id: 1, name: ' posts', links: '', icon: <FaBlog /> },
  { id: 2, name: 'add post', links: 'add-post', icon: <MdEditNote /> },
  { id: 3, name: 'edit post', links: 'edit-post', icon: <FaEdit /> },
  { id: 4, name: 'delete post', links: 'delete-post', icon: <MdDeleteSweep /> },
  { id: 5, name: 'profile', links: 'profile', icon: <FaUserCircle/> },
];
